import React, { useEffect } from 'react';

import { useLocation } from 'react-router-dom';
import p1 from '../Assets/Plus-1.jpg';
import p2 from '../Assets/Plus-2.jpg';
import p3 from '../Assets/Plus-3.jpg';
import p6 from '../Assets/plus-6.jpg';
import FormationPlusCarousel from './FormationPlusCarousel';

import logo from '../Assets/LOGO_CFCAE.png';

const Plus = () => {
	const { hash } = useLocation();

	useEffect(() => {
		if (hash) {
			const target = document.querySelector(hash);
			if (target) {
				const yOffset = 100; // Offset for fixed navbar
				const yPosition =
					target.getBoundingClientRect().top +
					window.scrollY +
					yOffset;
				window.scrollTo({ top: yPosition, behavior: 'smooth' });
			}
		}
	}, [hash]);
	return (
		<div className='bg-white mx-auto w-[80%] text-gray-900'>
			{/* Header Section */}
			<div id='target-section' className='py-8 px-4 text-center'>
				<img
					src={logo}
					alt='CFCAE Logo'
					className='my-4 mx-auto w-[300px]'
				/>
				<h1 className='text-3xl lg:text-4xl font-bold text-[#87152B]'>
					Résumé de l'offre de service de CFCAE
				</h1>
			</div>

			{/* Main Content Section */}
			<div className='px-4 lg:px-12 py-8 flex flex-col items-center justify-center gap-8'>
				{/* Left Text Section */}
				<div className='w-[80%] space-y-8 text-justify flex flex-col items-center justify-center'>
					<p>
						<span className='font-normal text-[#87152B] md:text-4xl sm:text-3xl text-2xl'>
							C
						</span>
						abinet d’accompagnement sur le développement des
						entreprises industrielles notamment dans le domaine
						électrique, et spécialement dans la fabrication de
						poteaux béton arme ou précontrainte à travers les
						diagnostics, expertises, conseils et la formations.
						Notre cabinet s’engage à vous apporter des solutions
						adaptées à vos besoins. En mobilisant toutes les
						ressources nécessaires à la réussite de vos projets et
						le développement de votre personnel. Nous sommes engagés
						à répondre à vos attentes et nous veillons à vous
						fournir des services qui apporteront une contribution
						pertinente à la réussite de vos projets.
					</p>
				</div>
			</div>
			<div className='w-full '>
				<FormationPlusCarousel />
			</div>
		</div>
	);
};

export default Plus;
